import { render, staticRenderFns } from "./PropSentimentPie.vue?vue&type=template&id=6b7549f0&"
import script from "./PropSentimentPie.vue?vue&type=script&lang=js&"
export * from "./PropSentimentPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports